function initEssentialStickyATC() {
  var stickyAtc = document.querySelector("#stickyAtc");
  var mainAtc = document.querySelector("#mainAddToCart");
  if (!stickyAtc || !mainAtc || !("IntersectionObserver" in window)) return;
  if (stickyAtc._pwObserver) stickyAtc._pwObserver.disconnect();
  var observer = new IntersectionObserver(function (entries) {
    var entry = entries[0];
    if (!entry) return;
    var shouldShow = !entry.isIntersecting;
    stickyAtc.classList.toggle("is-visible", shouldShow);
    stickyAtc.setAttribute("aria-hidden", shouldShow ? "false" : "true");
  }, { threshold: 0.15 });
  observer.observe(mainAtc);
  stickyAtc._pwObserver = observer;
}

function bootEssentialB(force) {
  var root = document.querySelector("[data-essential-b]");
  var isEssentialBPage = !!(root || document.body.classList.contains("essential-ab-b"));
  if (!isEssentialBPage) return;
  if (!root) root = document.body;
  if (!force && root.getAttribute("data-essential-b-ready") === "1") return;
  root.setAttribute("data-essential-b-ready", "1");

  var product = {};
  var productEl = document.querySelector("[data-essential-b-product]");
  if (productEl) {
    try {
      product = JSON.parse(productEl.textContent);
    } catch (e) {
      product = {};
    }
  }

  var store = window.__pwEssentialBStore = window.__pwEssentialBStore || {
    state: { location: "clinic", addons: new Set(), quantity: 1 },
    isAdding: false,
    product: {}
  };
  var state = store.state;
  store.product = product;
  // Multi-section Essential B pages place markup across several Shopify sections.
  // Scope queries to the whole document so IDs/classes still resolve after splits.
  var scope = document;
  var $ = function (sel) { return scope.querySelector(sel); };
  var $$ = function (sel) { return Array.prototype.slice.call(scope.querySelectorAll(sel)); };
  var stickyNode = function (sel) { return document.querySelector(sel); };

  function normalize(value) {
    return String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").replace(/\s+/g, " ").trim();
  }

  function formatMoney(cents) {
    var format = product.moneyFormat || "AED {{amount}}";
    var amount = (Number(cents || 0) / 100).toFixed(2);
    var noDecimals = amount.replace(/\.00$/, "");
    var comma = function (value) {
      var parts = value.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    };
    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, comma(noDecimals))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, comma(amount))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, comma(amount));
  }

  function locationKeyFromValue(value) {
    var n = normalize(value);
    if (n.indexOf("other") !== -1) return "uae-home";
    if (n.indexOf("homecare") !== -1 || (n.indexOf("dubai") !== -1 && n.indexOf("science") === -1)) return "dubai-home";
    if (n.indexOf("science") !== -1 || n.indexOf("precision") !== -1 || n.indexOf("clinic") !== -1) return "clinic";
    return "";
  }

  function extraKey() {
    var cortisol = state.addons.has("cortisol");
    var gut = state.addons.has("gut");
    if (cortisol && gut) return "both";
    if (cortisol) return "cortisol";
    if (gut) return "gut";
    return "none";
  }

  function extraKeyFromValue(value) {
    var n = normalize(value);
    var cortisol = n.indexOf("cortisol") !== -1;
    var gut = n.indexOf("gut") !== -1 || n.indexOf("microbiome") !== -1;
    if (cortisol && gut) return "both";
    if (cortisol) return "cortisol";
    if (gut) return "gut";
    return "none";
  }

  function optionValue(variant, index) {
    if (!variant || index < 0) return "";
    if (variant.options && variant.options[index] != null) return variant.options[index];
    return variant["option" + (index + 1)] || "";
  }

  function matchVariant() {
    var variants = product.variants || [];
    if (!variants.length) return null;
    var wantExtra = extraKey();
    var wantRetest = state.addons.has("retest");
    var matches = variants.filter(function (variant) {
      if (locationKeyFromValue(optionValue(variant, 0) || variant.title) !== state.location) return false;
      var retestValue = normalize(optionValue(variant, 1));
      var isRetest = retestValue.indexOf("retest") !== -1 && retestValue.indexOf("no ") !== 0 && retestValue.indexOf("without") === -1;
      if (wantRetest !== isRetest) return false;
      return extraKeyFromValue(optionValue(variant, 2)) === wantExtra;
    });
    return matches.find(function (variant) { return variant.available; }) || matches[0] || variants[0];
  }

  function selectedLabel(selector) {
    var card = $(selector);
    var strong = card && card.querySelector("strong");
    return strong ? strong.textContent.trim() : "";
  }

  function updateUI() {
    var variant = matchVariant();
    var unit = variant ? Number(variant.price) : Number(product.basePrice || 0);
    var total = unit * state.quantity;
    var formatted = formatMoney(total);
    var unitFormatted = formatMoney(unit);
    var totalEl = $("#purchaseTotal");
    var stickyEl = stickyNode("#stickyTotal");
    var finalEl = $("#finalPrice");
    var baseEl = $(".pw-price");
    if (totalEl) totalEl.textContent = formatted;
    if (stickyEl) stickyEl.textContent = formatted;
    if (finalEl) finalEl.textContent = formatted;
    if (baseEl) baseEl.textContent = unitFormatted;
    ["#mainAddToCart", "#finalAddToCart"].forEach(function (sel) {
      var button = $(sel);
      if (button && button.getAttribute("aria-busy") !== "true") {
        button.textContent = variant && variant.available ? "ADD TO CART · " + formatted : "SOLD OUT";
        button.disabled = !variant || !variant.available;
      }
    });
    var stickyBtn = stickyNode("#stickyAddToCart");
    if (stickyBtn && stickyBtn.getAttribute("aria-busy") !== "true") {
      stickyBtn.disabled = !variant || !variant.available;
    }
    var buyNow = $("#buyNow");
    if (buyNow && buyNow.getAttribute("aria-busy") !== "true") buyNow.disabled = !variant || !variant.available;
    var qty = $("#qtyValue");
    if (qty) qty.textContent = String(state.quantity);
    $$(".pw-option-card").forEach(function (card) {
      var selected = card.getAttribute("data-location-option") === state.location;
      card.classList.toggle("is-selected", selected);
      var input = card.querySelector("input");
      if (input) input.checked = selected;
    });
    $$(".pw-addon-card").forEach(function (card) {
      var selected = state.addons.has(card.getAttribute("data-addon-id"));
      card.classList.toggle("is-selected", selected);
      var input = card.querySelector("input");
      if (input) input.checked = selected;
    });
    root.setAttribute("data-variant-id", variant ? String(variant.id) : "");
  }

  function setCartCount(count) {
    var el = $("#cartCount");
    if (!el) return;
    var value = Math.max(0, Number(count) || 0);
    el.textContent = value < 100 ? String(value) : "99+";
    el.classList.toggle("is-empty", value === 0);
  }

  function showError(message) {
    var el = $("#cartError");
    if (!el) return;
    el.hidden = !message;
    el.textContent = message || "";
  }

  function cartSectionId() {
    var drawer = document.getElementById("CartDrawer");
    if (!drawer) return "";
    var section = drawer.closest(".shopify-section");
    return section ? section.id.replace("shopify-section-", "") : "";
  }

  function openThemeCart() {
    if ((root.getAttribute("data-cart-type") || "drawer") !== "drawer") {
      window.location.href = "/cart";
      return;
    }
    var drawer = document.getElementById("CartDrawer");
    if (drawer && typeof drawer.showDialog === "function") drawer.showDialog();
  }

  function dispatchCartUpdate(addResponse, cart) {
    var sectionId = cartSectionId();
    var sections = addResponse && addResponse.sections ? addResponse.sections : undefined;
    var quantity = state.quantity;
    document.dispatchEvent(new CustomEvent("cart:update", {
      bubbles: true,
      detail: {
        resource: cart || addResponse,
        sourceId: "essential-ab-b",
        data: {
          itemCount: quantity,
          isIncremental: true,
          source: "essential-ab-b",
          productId: product.id,
          sections: sections,
          variantId: root.getAttribute("data-variant-id")
        }
      }
    }));
    document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent("product-ajax:added", {
      bubbles: true,
      detail: { product: addResponse, cart: cart, source: "essential-ab-b" }
    }));
    if (sectionId && sections && sections[sectionId]) {
      var drawer = document.getElementById("CartDrawer");
      if (drawer && typeof drawer.showDialog === "function" && (root.getAttribute("data-cart-type") || "drawer") === "drawer") {
        drawer.showDialog();
      }
    }
  }

  function addToCart(checkout) {
    if (store.isAdding) return;
    var variant = matchVariant();
    if (!variant || !variant.available) {
      showError("This Essential option is currently sold out.");
      return;
    }
    store.isAdding = true;
    showError("");
    var buttons = ["#mainAddToCart", "#finalAddToCart", "#buyNow"].map($).filter(Boolean);
    var stickyDuringAdd = stickyNode("#stickyAddToCart");
    if (stickyDuringAdd) buttons.push(stickyDuringAdd);
    var labels = buttons.map(function (button) { return button.textContent; });
    buttons.forEach(function (button) {
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
    });
    var main = $("#mainAddToCart");
    if (main) main.textContent = "ADDING...";
    var sectionId = cartSectionId();
    var payload = {
      items: [{
        id: Number(variant.id),
        quantity: state.quantity,
        properties: {
          _experiment: "essential_lp",
          _experiment_variant: "B",
          _assessment_location: selectedLabel('.pw-option-card.is-selected') || state.location
        }
      }]
    };
    if (sectionId) {
      payload.sections = sectionId;
      payload.sections_url = window.location.pathname;
    }
    fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          showError((result.data && (result.data.description || result.data.message)) || "Could not add to cart");
          return;
        }
        return fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            setCartCount(cart.item_count);
            if (checkout) {
              document.dispatchEvent(new CustomEvent("product-ajax:added", {
                bubbles: true,
                detail: { product: result.data, cart: cart, source: "essential-ab-b" }
              }));
              window.location.href = "/checkout";
              return;
            }
            dispatchCartUpdate(result.data, cart);
            if ((root.getAttribute("data-cart-type") || "drawer") !== "drawer") {
              window.location.href = "/cart";
            }
          });
      })
      .catch(function () {
        showError("Could not add to cart");
      })
      .finally(function () {
        store.isAdding = false;
        buttons.forEach(function (button, index) {
          button.removeAttribute("aria-busy");
          button.textContent = labels[index];
        });
        updateUI();
      });
  }

  function bindOnce(el, type, handler, key) {
    if (!el) return;
    var flag = "_pwEssentialBound_" + key;
    if (el[flag]) return;
    el[flag] = true;
    el.addEventListener(type, handler);
  }

  $$(".pw-option-card").forEach(function (card) {
    bindOnce(card, "click", function () {
      state.location = card.getAttribute("data-location-option") || "clinic";
      updateUI();
    }, "location");
  });
  $$(".pw-addon-card").forEach(function (card) {
    bindOnce(card, "click", function (event) {
      event.preventDefault();
      var id = card.getAttribute("data-addon-id");
      if (!id) return;
      if (state.addons.has(id)) state.addons.delete(id);
      else state.addons.add(id);
      updateUI();
    }, "addon");
  });
  var minus = $("#qtyMinus");
  var plus = $("#qtyPlus");
  bindOnce(minus, "click", function () { state.quantity = Math.max(1, state.quantity - 1); updateUI(); }, "qtyMinus");
  bindOnce(plus, "click", function () { state.quantity += 1; updateUI(); }, "qtyPlus");
  var mainAdd = $("#mainAddToCart");
  var stickyAdd = stickyNode("#stickyAddToCart");
  var finalAdd = $("#finalAddToCart");
  var buyNow = $("#buyNow");
  bindOnce(mainAdd, "click", function () { addToCart(false); }, "mainAdd");
  bindOnce(stickyAdd, "click", function () { addToCart(false); }, "stickyAdd");
  bindOnce(finalAdd, "click", function () { addToCart(false); }, "finalAdd");
  bindOnce(buyNow, "click", function () { addToCart(true); }, "buyNow");
  var cartOpen = $("#cartOpen");
  bindOnce(cartOpen, "click", openThemeCart, "cartOpen");

  initEssentialStickyATC();

  var galleryTrack = $("#galleryTrack");
  var gallerySlides = galleryTrack ? $$(".pw-gallery-slide") : [];
  if (galleryTrack && gallerySlides.length && !galleryTrack._pwGalleryBound) {
    galleryTrack._pwGalleryBound = true;
    var dotsHost = $("#galleryDots");
    if (dotsHost) dotsHost.innerHTML = "";
    gallerySlides.forEach(function (_, index) {
      var dot = document.createElement("button");
      dot.className = "pw-gallery-dot" + (index === 0 ? " is-active" : "");
      dot.type = "button";
      dot.setAttribute("aria-label", "Go to image " + (index + 1));
      dot.addEventListener("click", function () {
        gallerySlides[index].scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      });
      if (dotsHost) dotsHost.appendChild(dot);
    });
    var updateGallery = function () {
      var center = galleryTrack.scrollLeft + galleryTrack.clientWidth / 2;
      var closest = 0;
      var distance = Infinity;
      gallerySlides.forEach(function (slide, index) {
        var d = Math.abs(center - (slide.offsetLeft + slide.clientWidth / 2));
        if (d < distance) { distance = d; closest = index; }
      });
      $$(".pw-gallery-dot").forEach(function (dot, index) { dot.classList.toggle("is-active", index === closest); });
      var count = $("#galleryCount");
      if (count) count.textContent = (closest + 1) + " / " + gallerySlides.length;
    };
    galleryTrack.addEventListener("scroll", function () { requestAnimationFrame(updateGallery); }, { passive: true });
    updateGallery();
  }

  $$(".pw-faq-q").forEach(function (button) {
    bindOnce(button, "click", function () {
      var target = document.getElementById(button.getAttribute("aria-controls"));
      var willOpen = button.getAttribute("aria-expanded") !== "true";
      $$(".pw-faq-q").forEach(function (other) {
        other.setAttribute("aria-expanded", "false");
        var panel = document.getElementById(other.getAttribute("aria-controls"));
        if (panel) panel.classList.remove("is-open");
      });
      if (willOpen && target) {
        button.setAttribute("aria-expanded", "true");
        target.classList.add("is-open");
      }
    }, "faq");
  });

  var compareToggle = $("#compareToggle");
  if (compareToggle) {
    bindOnce(compareToggle, "click", function () {
      var details = $("#compareDetails");
      if (!details) return;
      var open = details.classList.toggle("is-open");
      compareToggle.setAttribute("aria-expanded", String(open));
      var openLabel = compareToggle.getAttribute("data-label-open") || "Hide comparison";
      var closedLabel = compareToggle.getAttribute("data-label-closed") || "Compare assessments";
      compareToggle.textContent = open ? openLabel : closedLabel;
    }, "compare");
  }

  var experienceTrack = $("#experienceTrack");
  if (experienceTrack && experienceTrack.getAttribute("data-experience-scroll") !== "1") {
    experienceTrack.setAttribute("data-experience-scroll", "1");
    var drag = null;
    var suppressClick = false;
    experienceTrack.addEventListener("pointerdown", function (event) {
      if (event.pointerType !== "mouse" || event.button !== 0) return;
      drag = { id: event.pointerId, x: event.clientX, left: experienceTrack.scrollLeft, moved: false };
    });
    experienceTrack.addEventListener("pointermove", function (event) {
      if (!drag || event.pointerId !== drag.id) return;
      var dx = event.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) < 8) return;
      drag.moved = true;
      experienceTrack.classList.add("is-dragging");
      experienceTrack.scrollLeft = drag.left - dx;
      if (experienceTrack.setPointerCapture) {
        try { experienceTrack.setPointerCapture(event.pointerId); } catch (error) {}
      }
    });
    var endDrag = function (event) {
      if (!drag || (event && event.pointerId !== drag.id)) return;
      if (drag.moved) suppressClick = true;
      drag = null;
      experienceTrack.classList.remove("is-dragging");
    };
    experienceTrack.addEventListener("pointerup", endDrag);
    experienceTrack.addEventListener("pointercancel", endDrag);
    experienceTrack.addEventListener("click", function (event) {
      if (!suppressClick) return;
      suppressClick = false;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  }

  $$(".pw-video-card").forEach(function (card) {
    card.addEventListener("click", function () {
      $$(".pw-video-card").forEach(function (other) { if (other !== card) other.classList.remove("is-playing"); });
      card.classList.toggle("is-playing");
    });
  });

  $$(".pw-footer-toggle").forEach(function (button) {
    button.addEventListener("click", function () {
      var links = button.nextElementSibling;
      if (!links) return;
      var open = links.classList.toggle("is-open");
      button.setAttribute("aria-expanded", String(open));
      var icon = button.querySelector("span");
      if (icon) icon.textContent = open ? "−" : "+";
    });
  });

  function openMenu() {
    var menu = $("#mobileMenu");
    var backdrop = $("#backdrop");
    if (!menu) return;
    menu.classList.add("is-open");
    menu.setAttribute("aria-hidden", "false");
    if (backdrop) backdrop.classList.add("is-open");
    document.body.classList.add("pw-essential-b-menu-open");
  }
  function closeMenu() {
    var menu = $("#mobileMenu");
    var backdrop = $("#backdrop");
    if (menu) {
      menu.classList.remove("is-open");
      menu.setAttribute("aria-hidden", "true");
    }
    if (backdrop) backdrop.classList.remove("is-open");
    document.body.classList.remove("pw-essential-b-menu-open");
  }
  var menuOpen = $("#menuOpen");
  var menuClose = $("#menuClose");
  var backdrop = $("#backdrop");
  if (menuOpen) menuOpen.addEventListener("click", openMenu);
  if (menuClose) menuClose.addEventListener("click", closeMenu);
  if (backdrop) backdrop.addEventListener("click", closeMenu);
  $$("#mobileMenu a").forEach(function (link) { link.addEventListener("click", closeMenu); });
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeMenu();
  });

  fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
    .then(function (response) { return response.json(); })
    .then(function (cart) { setCartCount(cart.item_count); })
    .catch(function () {});

  updateUI();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootEssentialB);
} else {
  bootEssentialB();
}

document.addEventListener("shopify:section:load", function (event) {
  var section = event.target;
  if (!section || !section.querySelector) return;
  var onEssentialB =
    document.body.classList.contains("essential-ab-b") ||
    section.querySelector("[data-essential-b]") ||
    section.querySelector(".pw-essential-b");
  if (!onEssentialB) return;
  var root = document.querySelector("[data-essential-b]") || document.body;
  root.removeAttribute("data-essential-b-ready");
  bootEssentialB(true);
  initEssentialStickyATC();
});
